<template>
    <div class="star-rate-wrapper" :class="[colorRender(num)]">
        <span
            class="star"
            :class="starRender(num, key)"
            v-for="key in 4"
            :key="key"
        ></span>
    </div>
</template>
<script>
    export default {
        props:{
            num:{
                type:Number,
                default:0
            },
            color:{
                type:String,
                default:'red'
            }
        },
        methods:{
            starRender(num, key) {
                return { active: key <= Math.ceil(num), half: num == 0.5 };
            },
            colorRender(num){
              let color = 'yellow';
              if(num == 4) {
                color = 'red';
              } 
              if(num <= 1) {
                color = 'green'
              }
              return color;
            }
        }
    }
</script>
<style scoped>
.star-rate-wrapper{
    position: relative;
}
.star-rate-wrapper .star {
  display: inline-block;
  height: 0.11rem;
  width: 0.12rem;
  margin-left: 0.06rem;
  background-image: url(./images/gray-star-icon.png);
  background-size: 100%;
}

.star-rate-wrapper .star.active {
  background-image: url(./images/red-star-icon.png);
}
.star-rate-wrapper.yellow .star.active.half {
  background-image: url(./images/yellow-star-half.png);
}
.star-rate-wrapper.yellow .star.active {
  background-image: url(./images/yellow-star-icon.png);
}
.star-rate-wrapper.green .star.active {
  background-image: url(./images/green-star-icon.png);
}
.star-rate-wrapper.green .star.active.half {
  background-image: url(./images/green-star-half.png);
}
</style>